import {ValueObject} from '@s-ui/domain'

export class CreateTradeRequestValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.adId
   * @param {Object} data.buyer
   */

  static create = ({adId, buyer}) => {
    return new CreateTradeRequestValueObject({adId, buyer})
  }
}
